module.exports = __webpack_public_path__ + "img/N2.251300ee.png";